import { __awaiter, __extends, __generator } from "tslib";
import { MinicartActions } from '../MiniCartActions/MinicartActions';
import { PageMap } from '@wix/wixstores-client-core';
import { SPECS } from '../../constants';
var SideCartActions = /** @class */ (function (_super) {
    __extends(SideCartActions, _super);
    function SideCartActions() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    SideCartActions.prototype.showMiniCartOrSideCart = function (options) {
        if (options === void 0) { options = { allowShowingSideCartOnMobile: false }; }
        return __awaiter(this, void 0, void 0, function () {
            var dontShowSideCartOnMobile, blockOpenSideCart, sideCartLightbox;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        dontShowSideCartOnMobile = this.siteStore.experiments.enabled(SPECS.StopCallingGetClientConfigInCartIcon)
                            ? this.siteStore.storage.memory.getItem('dontShowSideCartOnMobile') === 'true'
                            : this.siteStore.dontShowSideCartOnMobile;
                        blockOpenSideCart = this.siteStore.isMobile() && dontShowSideCartOnMobile && !options.allowShowingSideCartOnMobile;
                        if (blockOpenSideCart) {
                            throw Error("Migrated Side Cart can't be open in mobile");
                        }
                        return [4 /*yield*/, this.getSideCartLightbox()];
                    case 1:
                        sideCartLightbox = _a.sent();
                        if (sideCartLightbox) {
                            this.openSideCart(sideCartLightbox.id);
                        }
                        else {
                            return [2 /*return*/, this.showMiniCartWithoutMobile()];
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    SideCartActions.prototype.navigateToCart = function (origin) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.siteStore.navigate({
                        sectionId: PageMap.CART,
                        queryParams: { origin: origin },
                    }, true)];
            });
        });
    };
    SideCartActions.prototype.showMiniCartWithoutMobile = function () {
        if (this.siteStore.experiments.enabled(SPECS.NavigateToCartWhenCallShowMiniCart)) {
            return this.navigateToCart(this.origin);
        }
        if (this.siteStore.isMobile()) {
            throw Error("can't open mini cart in mobile");
        }
        this.showMinicart();
    };
    SideCartActions.prototype.openSideCart = function (id) {
        var _a;
        if (((_a = this.siteStore.siteApis.currentPage) === null || _a === void 0 ? void 0 : _a.type) === 'lightbox') {
            this.siteStore.windowApis.lightbox.close();
        }
        void this.siteStore.windowApis.openLightboxById(id, {});
    };
    SideCartActions.prototype.getSideCartLightbox = function () {
        var _a;
        return __awaiter(this, void 0, void 0, function () {
            var siteStructure;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, this.siteStore.wixCodeApi.site.getSiteStructure({ includePageId: true })];
                    case 1:
                        siteStructure = _b.sent();
                        return [2 /*return*/, (_a = siteStructure.lightboxes) === null || _a === void 0 ? void 0 : _a.find(function (lightbox) { return lightbox.tpaPageId === PageMap.SIDE_CART; })];
                }
            });
        });
    };
    SideCartActions.prototype.getSideCartName = function () {
        return __awaiter(this, void 0, void 0, function () {
            var sideCart;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getSideCartLightbox()];
                    case 1:
                        sideCart = _a.sent();
                        return [2 /*return*/, sideCart === null || sideCart === void 0 ? void 0 : sideCart.name];
                }
            });
        });
    };
    SideCartActions.prototype.hasSideCart = function () {
        return __awaiter(this, void 0, void 0, function () {
            var sideCartLightbox;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getSideCartLightbox()];
                    case 1:
                        sideCartLightbox = _a.sent();
                        return [2 /*return*/, !!sideCartLightbox];
                }
            });
        });
    };
    return SideCartActions;
}(MinicartActions));
export { SideCartActions };
//# sourceMappingURL=SideCartActions.js.map